export const MAILING_REQUEST_COUNT = 15;
export const MAILINGRECIPIENTS_REQUEST_COUNT = 15;